/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../locale-data/index.js (ignored)
// module id = 1
// module chunks = 18